import React from 'react';
import { Admin, Resource } from 'react-admin';
import { dataProvider } from './dataProvider';
import MyDashboard from './MyDashboard';
import ProductShow from './ProductShow';

const App = () => (
  <Admin dataProvider={dataProvider}>
    <Resource name="products" list={MyDashboard} show={ProductShow} />
  </Admin>
);

export default App;
